module.exports = __webpack_public_path__ + "static/media/Oct_2025_3.80be000e.webp";